import { QuizResultEnum, QuizRetakeTypeEnum, RoleplayContentType } from '@/types/schema';

import { RoleplayDetailsPerformanceFragment } from '../../graphql/fragments/generated/RoleplayDetailsPerformance';

type RoleplayRetakeConfig = Pick<RoleplayContentType, 'retakeType' | 'retakeAllowedCount'>;

export const getAllowedAttempts = (roleplay: RoleplayRetakeConfig): number => {
  if (!roleplay.retakeType || roleplay.retakeType === QuizRetakeTypeEnum.None) return 1;
  return (roleplay.retakeAllowedCount ?? 0) + 1;
};

export const getCanRetakeRoleplay = (
  roleplay: RoleplayRetakeConfig,
  roleplayPerformance?: RoleplayDetailsPerformanceFragment,
): { canRetakeRoleplay: boolean } => {
  const allowedAttempts = getAllowedAttempts(roleplay);
  const attemptsHistory = roleplayPerformance?.attempts || [];
  const isRetakeLeft = attemptsHistory.length < allowedAttempts;

  switch (roleplay.retakeType) {
    case QuizRetakeTypeEnum.FailedLearners: {
      const hasFailed = roleplayPerformance?.maxSubmissionDetails?.result === QuizResultEnum.Fail;
      return { canRetakeRoleplay: hasFailed && isRetakeLeft };
    }
    default:
      return { canRetakeRoleplay: isRetakeLeft };
  }
};

export default getCanRetakeRoleplay;
